import {
  BLOCKED_REDIRECT_PREFIXES,
  safeRedirectPath,
} from "../../shared/auth/redirect.js";
import { pathPrefixesWhere } from "../../shared/routes/index.js";

export const AUTH_PAGE_PATHS = pathPrefixesWhere(
  ({ id }) => id.startsWith("auth.") || id === "print-box-link",
);

const isUnder = (path, base) =>
  path === base || (base !== "/" && path.startsWith(`${base}/`));

export const showsFooter = (pathname) => {
  const path = pathname.toLowerCase();

  return !AUTH_PAGE_PATHS.some((base) => isUnder(path, base));
};

export const destinationAfterLogin = ({
  r,
  origin,
  landing,
  preferLanding = false,
}) => {
  const back = safeRedirectPath(r, {
    origin,
    blocked: BLOCKED_REDIRECT_PREFIXES,
  });

  return (preferLanding ? landing ?? back : back ?? landing) ?? "/";
};
